var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.editor)?_c('div',{staticClass:"kv-editor kv-markdown-input",class:{ 'kv-disabled': _vm.disabled },style:({ '--editor-rows': _vm.rows })},[_c('editor-content',{attrs:{"editor":_vm.editor,"spellcheck":"false"}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }